import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core'
import { NgClass } from '@angular/common';
import { LegalType } from '../../legal'
import { ResponsiveComponent } from '@nx-superprep/shared';
import { takeUntil } from 'rxjs';

@Component({
    selector: 'pop-ui-footerlte',
    standalone: true,
    templateUrl: './footerlte.component.html',
    styleUrls: ['./footerlte.component.scss'],
    imports: [NgClass]
})
export class FooterlteComponent extends ResponsiveComponent implements OnInit, OnDestroy {
  @Input() legal: LegalType|undefined
  @Output() legalChange = new EventEmitter<LegalType>()

  @Input() frame_alt = 'popstudy'
  @Input() frame_src = '/assets/icons/popstudy.svg'
  @Input() iconsociallinkedin_alt = 'iconsociallinkedin'
  @Input() iconsociallinkedin_src = '/assets/icons/iconsociallinkedin.svg'
  @Input() iconsocialfacebook_alt = 'iconsocialfacebook'
  @Input() iconsocialfacebook_src = '/assets/icons/iconsocialfacebook.svg'
  @Input() iconsocialtwitter_alt = 'iconsocialtwitter'
  @Input() iconsocialtwitter_src = '/assets/icons/iconsocialtwitter.svg'

  currentYear = new Date().getFullYear()

  terms = ''
  privacy = ''
  copyright = ''
  lte = ''

  updateTexts() {
    this.terms = this.isWeb ? 'Terms of Use' : 'Terms'
    this.privacy = this.isWeb ? 'Privacy Policy' : 'Privacy'
    this.copyright = this.isWeb ? `By Longtail Education ©${this.currentYear}. All rights reserved.` : 'Longtail Education'
    this.lte = 'Longtail Education'
  }

  onSelect(item: LegalType) {
    this.legal = item
    this.legalChange.emit(this.legal)
  }

  override ngOnInit() {
    super.ngOnInit()
    this.updateTexts()
    this.didBreakpointChange.pipe(takeUntil(this.onDestroy)).subscribe(() => this.updateTexts())
  }

  constructor() {
    super()
    super.rootClassName = 'footerlte-root-class-name'
  }
}
